import { useRef, useEffect } from 'react';

interface IUseSetInputFocusProps {
    isOpen?: boolean;
}

export const useSetInputFocus = ({ isOpen }: IUseSetInputFocusProps) => {
    const ref = useRef<HTMLInputElement>(null);
    useEffect(() => {
        if (isOpen) {
            ref.current?.focus({ preventScroll: true });
        }
    }, [isOpen]);
    return ref;
};
